import { Component, Input } from '@angular/core';

@Component({
  selector: 'sales-report-skeleton',
  templateUrl: './sales-report-skeleton.component.html',
  host: { class: 'sales-report-skeleton' },
  styleUrls: ['./sales-report-skeleton.component.scss']
})
export class SalesReportSkeletonComponent {
  @Input() public retailerName = '';
  @Input() public dateFrom: Date | null;
  @Input() public dateTo: Date | null;

  public readonly rows = [0, 1, 2, 3];
  public readonly days = [0, 1, 2, 3, 4, 5, 6, 7];
}
